module.exports = __webpack_public_path__ + "d856f11cd822169e9dc41501c22c4777.otf";